import React from "react"
import Helmet from "react-helmet"
import { Row, Col } from "antd"
import Footer from "../common/footer"
import Subscribe from "../components/subscribe/"
import { Hero } from "../components/hero"
import Layout from "../common/layout"
import Navigation from "../common/navigation"
import heroBG from "../assets/images/team/heroBG.png"
import current_access from "../assets/images/solutions/current_access.png"
import current_access_icon from "../assets/images/solutions/current_access_icon.svg"
import swiftlane_mobile from "../assets/images/solutions/swiftlane_mobile.png"
import swiftlane_mobile_icon from "../assets/images/solutions/swiftlane_mobile_icon.svg"
import swiftlane_face_icon from "../assets/images/solutions/swiftlane_face_icon.svg"
import swiftlane_face from "../assets/images/solutions/swiftlane_face.png"

import high_security from "../assets/images/solutions/high_security.svg"
import two_factor_auth from "../assets/images/solutions/two_factor_auth.svg"
import encrypted_access from "../assets/images/solutions/encrypted_access.svg"
import extensive_controls from "../assets/images/icons/extensive_controls.svg"
import fast_entollment from "../assets/images/icons/fast_entollment.svg"
import real_time_activity_feed from "../assets/images/icons/real_time_activity_feed.svg"
import visual_verification from "../assets/images/solutions/visual_verification.svg"
import auditing from "../assets/images/icons/auditing.svg"
import frictionless from "../assets/images/solutions/frictionless.svg"

import carry_badges from "../assets/images/icons/carry_badges.svg"
import hands_free from "../assets/images/icons/hands_free.svg"
import HelmetScript from "../common/helmetScripts"
import "aos/dist/aos.css"
import "./index.scss"
import "../assets/styles/gallery-grid.scss"
import "../assets/styles/gallery-line.scss"
class SolutionsEnterprise extends React.Component {
  componentDidMount() {
    const AOS = require("aos")
    this.aos = AOS
    this.aos.init()
  }

  componentDidUpdate() {
    this.aos.refresh()
  }
  render() {
    return (
      <Layout location={this.props.location}>
        <Navigation />
        <HelmetScript />
        <Helmet title="Swiftlane Cloud Access Control for Enterprises, Offices, Businesses">
          <html lang="en" />
          <meta
            name="description"
            content="Set up Swiftlane commercial, office, and enterprise door access, with badges, key cards, facial(face) recognition and mobile app. Find out costs, reviews and what makes it the best access control system."
          ></meta>
          <meta
            name="keywords"
            content="swiftlane, enterprise access control, two factor authentication, physical access"
          />
        </Helmet>
        <Hero
          info="SWIFTLANE FOR ENTERPRISE"
          bg={heroBG}
          title="Modern access control for the enterprise"
          subTitle="With Swiftlane, unlock a new enterprise access experience for your company."
          getAQuote="Get a Quote"
        />
        <div className="wrapper products-page">
          <div className="home-content container homePage-design">
            {/* <h1>
              Modern access control for the enterprise. Two Factor
              Authentication, Seamless Access. Multi Site Management
            </h1> */}
            <div className="box">
              <Row>
                <Col md={12} className="text-left">
                  <div className="icon-set">
                    <img src={current_access_icon} alt="Door Icon" />
                  </div>
                  <h2>Current access control systems are insecure</h2>
                  <h3>
                    Current systems require operational burden, run on-premise,
                    and have security issues
                  </h3>
                  <ul>
                    <li>Key cards are easy to lose and clone</li>
                    <li>Tailgating risks</li>
                    <li>Hard to manage software</li>
                    <li>Huge operational burden</li>
                  </ul>
                </Col>
                <Col md={12} className="text-right">
                  <img src={current_access} alt="mobile" />
                </Col>
              </Row>
            </div>
            {/* end of box */}
            <div className="box">
              <Row gutter={16}>
                <Col md={12} className="text-left">
                  <img src={swiftlane_mobile} alt="face-recognition-access" />
                </Col>
                <Col md={12}>
                  <div className="icon-set">
                    <img src={swiftlane_mobile_icon} alt="Door Icon" />
                  </div>
                  <h2>Swiftlane mobile credentials are convenient to use</h2>
                  <h3>
                    Swiftlane app provides secure, encrypted unlock for your
                    doors from your mobile phones
                  </h3>
                  <ul>
                    <li>Convenient access from your phone</li>
                    <li>Easy enrollment</li>
                    <li>Encrypted, fast and secure access</li>
                  </ul>
                </Col>
              </Row>
            </div>
            {/* end of box */}

            <div className="box">
              <Row>
                <Col md={12} className="text-left">
                  <div className="icon-set">
                    <img src={swiftlane_face_icon} alt="Door Icon" />
                  </div>
                  <h2>Swiftlane face recognition access is fast and secure</h2>
                  <h3>
                    Just walk up to the door, look at the Swiftlane device and
                    the door unlocks
                  </h3>
                  <ul>
                    <li>Frictionless Access</li>
                    <li>Fast face enrollment</li>
                    <li>Designed for privacy</li>
                    <li>Unique two factor authentication</li>
                  </ul>
                </Col>
                <Col md={12} className="text-right">
                  <img src={swiftlane_face} alt="mobile" />
                </Col>
              </Row>
            </div>
            {/* end of box */}
            <section className="gallery-line">
              <div className="container">
                <h2>Create a Safe Office Environment</h2>
                <Row gutter={24}>
                  <Col lg={8} md={12} sm={12} xs={24}>
                    <div className="box">
                      <img src={high_security} alt="Icon" />
                      <h4>High Security</h4>
                      <p>
                        Encrypted mobile unlocks, high security face recognition
                        access
                      </p>
                    </div>
                  </Col>
                  <Col lg={8} md={12} sm={12} xs={24}>
                    <div className="box">
                      <img src={two_factor_auth} alt="Icon" />
                      <h4>Two Factor authentication</h4>
                      <p>
                        Combine face + mobile access to get strong two factor
                        authentication
                      </p>
                    </div>
                  </Col>
                  <Col lg={8} md={12} sm={12} xs={24}>
                    <div className="box">
                      <img src={encrypted_access} alt="Icon" />
                      <h4>Encrypted Access</h4>
                      <p>Reduce dependence on easy to clone proximity cards</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </section>

            <section className="gallery-section oldDesign">
              <div className="container">
                <h2>High Security at a fraction of cost</h2>
                <p>
                  Swiftlane’s access systems are designed for the modern
                  workplace, to improve operation visibility and empower your
                  security team
                </p>
                <Row gutter={24}>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={fast_entollment} alt="Icon" />
                    <h4>Easy enrollment</h4>
                    <p>
                      Enroll your users from your desk, no need to make a trip
                      to the server room
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={real_time_activity_feed} alt="Icon" />
                    <h4>Real time activity feed</h4>
                    <p>
                      Watch realtime access activity and visually verify every
                      person’s face
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={visual_verification} alt="Icon" />
                    <h4>Visual Verification</h4>
                    <p>
                      Visual verification at the door prevents unauthorized
                      access
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={auditing} alt="Icon" />
                    <h4>Auditing and Analytics</h4>
                    <p>
                      Identify anomalies and respond to events faster than ever
                    </p>
                  </Col>
                </Row>
              </div>
            </section>

            <section className="gallery-line">
              <div className="container">
                <h2>
                  <img src={frictionless} alt="Icon" />
                  Frictionless Access for Employees
                </h2>
                <Row gutter={24} type="flex" justify="center">
                  <Col lg={8} md={12} sm={12} xs={24}>
                    <div className="box">
                      <img src={carry_badges} alt="Icon" />
                      <h4>No need to carry badges</h4>
                      <p>Hassle free access</p>
                    </div>
                  </Col>
                  <Col lg={8} md={12} sm={12} xs={24}>
                    <div className="box">
                      <img src={hands_free} alt="Icon" />
                      <h4>Hands-free Access</h4>
                      <p>Walk in with your coffee and your bag in your hand</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </section>
          </div>
        </div>
        <Subscribe location={this.props.location} />
        <Footer />
      </Layout>
    )
  }
}

export default SolutionsEnterprise
